module.exports = __webpack_public_path__ + "static/logo_secondary-00d726f5454423ace95c67892484ccae.svg";